import { Pipe, PipeTransform } from '@angular/core';

/**
 *  This fulter is used to format a code by adding space between each n character, where n is passed by the user (default:4)
 */

@Pipe({
  name: 'formatCode'
})
export class FormatCode implements PipeTransform {

  transform(code: string, n: number): string {
    if (!n){
        n = 4;
    }
    const regExp = new RegExp('.{1,' + n + '}', 'g');
    const toreturn = code.match(regExp);
    return toreturn.join(' ');
  }

}
